import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button,
    Input
} from "reactstrap";
import SuspenseComponentText from '../../../views/components/SuspenseComponentText';
import useTimeout from "hooks/useTimeout";
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { postDeviceConfigCommand, getDeviceParameter } from "API";
import { commands } from "variables/commands";
// reactstrap components
const DeviceConfigCommandRemoteDeposit = ({ serial }) => {
    const [currentDeposit, setCurrentDeposit] = useState(null);
    const [deposit, setDeposit] = useState("");
    const [currentPrice, setCurrentPrice] = useState("");
    const [currentThreePrice, setCurrentThreePrice] = useState("");
    const [wrongDeposit, setWrongDeposit] = useState(true);
    const [tooBigDeposit, setTooBigDeposit] = useState(null);

    useEffect(() => {
        const numericValue = Number(deposit);
        const numericValueCurrentPrice = Number(currentPrice);
        const numericValueCurrentThreePrice = Number(currentThreePrice);
        if (numericValue >= 0 && !isNaN(numericValue)) {
            setWrongDeposit(false)
        } else {
            setWrongDeposit(true)
        }
        if (numericValue <= numericValueCurrentPrice && (currentThreePrice === '' || numericValue <= numericValueCurrentThreePrice)) {
            setTooBigDeposit(false)
        } else {
            setTooBigDeposit(true)
        }
    }, [deposit, currentPrice, currentThreePrice])
    
    useQuery('ConfigDeposit', () => getDeviceParameter(serial, commands.deposit_value_get), {
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            setCurrentDeposit(data.data.value)

        }
    });
    useQuery('ConfigPrice', () => getDeviceParameter(serial, commands.price), {
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            setCurrentPrice(data.data.value)
        }
    });
    useQuery('ConfigPriceThree', () => getDeviceParameter(serial, commands.price), {
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            setCurrentThreePrice(data.data.value)
        }
    });


    const handleDepositChange = (event) => {
        setDeposit(event.target.value);
    };

    const queryClient = useQueryClient()
    const { mutate: mutationConfigCommand, isLoading: mutationConfigCommandLoading, isError: mutationConfigCommandError, isSuccess: mutationConfigCommandSuccess, reset: mutationConfigCommandReset } = useMutation(
        {
            mutationFn: postDeviceConfigCommand,
            onSuccess: () => {
                // Invalidate and refetch
                timeoutClearDataPost();
                queryClient.invalidateQueries({ queryKey: ['Commands'] })
                queryClient.invalidateQueries({ queryKey: ['ConfigDeposit'] })
                queryClient.invalidateQueries({ queryKey: ['ConfigPrice'] })

            },
            onError: () => {
                // Invalidate and refetch
                timeoutClearDataPost();
                queryClient.invalidateQueries({ queryKey: ['Commands'] })
            },
        }
    );

    const handleSubmit = (event) => {
        event.preventDefault();
        if (mutationConfigCommandError === true || mutationConfigCommandLoading === true) {
            return false
        }
        const numericValue = Number(deposit);

        if (numericValue >= 0 && !isNaN(numericValue)) {
            mutationConfigCommand({
                serial: serial,
                commandName: commands.deposit_value_post,
                commandValue: deposit
            })
        } else {
            return false;
        }


    }

    const [timeoutClearDataPost] = useTimeout(() => {
        setDeposit("");
        mutationConfigCommandReset();
    }, 3000);


    return (
        <>
            <Col lg="6" md="6">
                <Card className="card-stats">
                    <CardBody>
                        <Row>
                            <Col xs="3">
                                <div className="info-icon text-center icon-success">
                                    <i className="tim-icons icon-money-coins" />
                                </div>
                            </Col>
                            <Col xs="9">
                                <div className="numbers">
                                    <p className="card-category">Command</p>
                                    <CardTitle tag="h4">

                                        {currentDeposit === null ? 'Change Deposit Price' : `Change Deposit Price : ${currentDeposit}`}
                                    </CardTitle>
                                </div>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col md='12' lg='6' className="flex-el-bottom-center">
                                <Input
                                    type="number"
                                    value={deposit}
                                    onChange={handleDepositChange}
                                    min={0}
                                />
                            </Col>
                            <Col md='12' lg='6' className="date-submit-center">
                                <div className='submit-button-row'>
                                    <Button className="btn-fill" disabled={tooBigDeposit || wrongDeposit || deposit === "" ? true : false} color={mutationConfigCommandError ? "danger" : mutationConfigCommandSuccess ? "success" : 'info'} type="submit"
                                        onClick={(event) => handleSubmit(event)}
                                    >
                                        {mutationConfigCommandLoading ? <SuspenseComponentText /> :
                                            mutationConfigCommandError ? (
                                                <div>
                                                    Failure <i className="tim-icons icon-simple-remove" />
                                                </div>
                                            ) : mutationConfigCommandSuccess ? (
                                                <div>
                                                    Success <i className="tim-icons icon-check-2" />
                                                </div>
                                            ) :
                                                `Submit`
                                        }
                                    </Button>
                                </div>
                            </Col>

                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default DeviceConfigCommandRemoteDeposit;